
// store.js
import { writable, derived } from 'svelte/store';

const createLocalStorageStore = (key) => {

	const { subscribe, set } = writable(null);

	// initialise
	const json = localStorage.getItem(key);

	if (json) {
		set(JSON.parse(json));
	}

	// this function updates the store and localStorage
	const setValue = value => {
		localStorage.setItem(key, JSON.stringify(value));

		// set the value in the store, which will notify everything subscribed to it
		set(value);
	}

	return {
     subscribe,
     set: setValue
	}
}

export const memberStore = createLocalStorageStore('test');

export const sessionStore = derived(memberStore, member => !!member)
